export default function estimateVelocity (weight, knownWeight, knownVelocity, useEfficiency = true) {
  //return ((-1227 / knownWeight) - 1.53) * weight + 0.8589 * knownVelocity + 1832
  let velocity = Math.sqrt(
    (knownWeight * knownVelocity ** 2) / weight
  )
  if (useEfficiency) {
    let dv = velocity - knownVelocity
    velocity = velocity - dv * .1027
  }
  return velocity
}

export function estimateVelocityFromCartridge(bullet, cartridge, barrelLength) {
  let v
  Object.keys(cartridge.velocities).forEach(velocityWeight => {
    if (velocityWeight === bullet.weight) v = cartridge.velocities[velocityWeight]
  })
  if (v) return parseInt(v)
  let bestDiff = Math.min()
  let bestWeight
  let bestVelocity
  Object.keys(cartridge.velocities).forEach(velocityWeight => {
    const diff = bullet.weight - velocityWeight
    if (diff < bestDiff) {
      bestDiff = diff
      bestWeight = velocityWeight
      bestVelocity = cartridge.velocities[velocityWeight]
    }
  })
  const mvChangePerInch = 20
  const velocityDelta = (barrelLength - cartridge.length) * mvChangePerInch
  const velocity = Math.round(Math.sqrt(
    (bestWeight * (bestVelocity ** 2)) / bullet.weight
  )) + velocityDelta
  return velocity
}
